import React from 'react';
import CalendarView from './Calendar';
import ListView from './List';
import TabView from '../TabView/TabView';

class Appointments extends React.Component{
    render(){
        return(
            <div className="appointments-page">
                <div className="container-fluid">
                    <div className="appointments-content">
                        <div className="top">
                            <h6>Appointments this month</h6>
                            {/* <button><i className="fa fa-plus-circle"></i>Add appointment</button> */}
                        </div>
                        <TabView>
                            Month
                            <span>
                                <CalendarView/>
                            </span>
                            List
                            <span>
                                <ListView/>
                            </span>
                        </TabView>
                    </div>
                </div>
            </div>
        )
    }
}

export default Appointments;


// WEBPACK FOOTER //
// ./src/components/appointments/Appointments.js